import { useMemo, useCallback } from 'react';

const SEARCH_PARAM_VALUE_SEPARATOR = ',';

function stringToArray(str: string): string[] {
  return decodeURIComponent(str).split(SEARCH_PARAM_VALUE_SEPARATOR);
}

function arrayToString(arr: string[]): string {
  return arr.join(SEARCH_PARAM_VALUE_SEPARATOR);
}

const updateSearchParamValue = (paramName: string, paramValue: string[], location: Location) => {
  const newUrl = new URL(location.href);
  const newSearchParams = newUrl.searchParams;
  if (!paramValue.length) {
    newSearchParams.delete(paramName);
  } else {
    newSearchParams.set(paramName, arrayToString(paramValue));
  }
  history.replaceState(null, '', decodeURIComponent(newUrl.toString()));
};

export type ManagedSearchParamReturn = [string[], (nextValue: string[]) => void];

export function useManagedSearchParam(searchParamName: string): ManagedSearchParamReturn {
  const urlSearchParams = typeof window !== 'undefined' ? window.location.search : '';

  const queryParamValue = useMemo(() => {
    const searchParamValue = new URLSearchParams(urlSearchParams).get(searchParamName);
    return searchParamValue ? stringToArray(searchParamValue) : [];
  }, [urlSearchParams, searchParamName]);

  const setQueryParamValue = useCallback(
    (nextValue: string[]) => {
      updateSearchParamValue(searchParamName, nextValue, location);
    },
    [searchParamName]
  );

  return [queryParamValue, setQueryParamValue];
}
